import CircularProgress from '@eversports/klimt-primitives/legacy/CircularProgress'
import Stack from '@eversports/klimt-primitives/legacy/Stack'

const LoadingPage = () => {
  return (
    <Stack justifyContent="center" alignItems="center" height="100vh">
      <CircularProgress />
    </Stack>
  )
}

export default LoadingPage
